import { jwtDecode } from "jwt-decode";

export const getToken = () => {
    return sessionStorage.getItem("token");
};

export const isAuthenticated = () => {
    const token = getToken();

    if (!token) return false;

    try {
        const decoded = jwtDecode(token);

        if (decoded.exp * 1000 <= Date.now()) {
            sessionStorage.removeItem("token");
            return false;
        }

        return true;
    } catch {
        sessionStorage.removeItem("token");
        return false;
    }
};

export const getUser = () => {
    const token = getToken();

    if (!token) return null;

    try {
        return jwtDecode(token);
    } catch {
        return null;
    }
};